import templateUrl from './edit-lead-office-team.component.html'

export const EditLeadOfficeTeamComponent = {
    controller: EditLeadOfficeTeamController,
    controllerAs: "vm",
    bindings: {
        leadOfficeTeam: "<",
        afterSubmit: "&"
    },
    templateUrl
};

function EditLeadOfficeTeamController($q, utilityService, leadOfficeTeamService) {
    'ngInject';
    const vm = this;
    vm.afterSubmit;
    vm.editForm;
    vm.onSubmit = onSubmit;
    vm.$onInit = activate;
    vm.errorMsg;
    vm.leadOfficeTeam;

    function activate() {
    }

    function onSubmit() {
        vm.errorMsg = null;
        let save;
        utilityService.showLoading();
        const request = {
            DisplayName: vm.leadOfficeTeam.DisplayName,
            OfficeName: vm.leadOfficeTeam.OfficeName,
            OfficeTeamID: vm.leadOfficeTeam.OfficeTeamID,
        }
        if (vm.leadOfficeTeam.OfficeTeamID) {
            save = leadOfficeTeamService.updateLeadOfficeTeam(vm.leadOfficeTeam.OfficeTeamID, request);
        } else {
            save = leadOfficeTeamService.createLeadOfficeTeam(request);
        }

        save
            .then(function () {
                vm.editForm.$setPristine();
                vm.afterSubmit({ leadOfficeTeam: vm.leadOfficeTeam, window: window });
            })
            .catch(function (ex) {
                alert(ex);
                utilityService.hideLoading();
            })
    }


}
